/* eslint-disable complexity */
import React, { useRef, useState } from "react";
import { Scope } from "@/api/calendar";
import dayjs, { Dayjs } from "dayjs";
import "./index.less";
import { getTypeImage, getDefaultColor } from "@/components/Calendars/utils/getTypeImage";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { message, Tooltip } from "antd";
import { ScheduleByUser } from "../BusyIdleHeader";

function ViewScheduleByUserItem ({
  selTime,
  schedule,
  styles,
  calendarScope
}: {
  selTime: Dayjs;
  schedule: ScheduleByUser;
  styles: React.CSSProperties;
  calendarScope: number;
}) {
  const { t } = useTranslation("calendar");
  const timePast = dayjs(schedule.endTime).isBefore(dayjs());
  const eTime = dayjs(selTime.format("YYYY-MM-DD") + " 23:59");
  const sTime = dayjs(selTime.format("YYYY-MM-DD") + " 00:00");
  const start = dayjs(schedule.beginTime).isBefore(sTime, "minute")
    ? sTime.format("HH:mm")
    : dayjs(schedule.beginTime).format("HH:mm");
  const end = dayjs(schedule.endTime).isAfter(eTime, "minute")
    ? eTime.format("HH:mm")
    : dayjs(schedule.endTime).format("HH:mm");

  schedule.color = schedule.color || getDefaultColor();

  const [hover, setHover] = useState(false);
  const backgroundColor = hover ? "rgba(222,237,255,1)" : "#FFFFFF";

  return (
    <Tooltip
      overlayClassName="calendar-view-title-tooltip"
      title={`${calendarScope === Scope.Busy ? t("busy") : schedule.title}${
        " " + start + "-" + end
      }`}
    >
      <div
        className={`view-schedule-item ${timePast ? "schedule-timepast" : ""}`}
        style={{
          backgroundColor: backgroundColor,
          color: "#000000",
          ...styles
        }}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <div
          className="pre-circle"
          style={{
            backgroundImage: `url(${getTypeImage(schedule.color)})`
          }}
        />
        <div className="view-schedule-item-content">
          <div className="title">{calendarScope === Scope.Busy ? t("busy") : schedule.title}</div>
          <div className="time">{`${start}-${end}`}</div>
        </div>
      </div>
    </Tooltip>
  );
}

export default ViewScheduleByUserItem;
